interface PaginationDotsProps {
    total: number;
    currentIndex: number;
    hidden?: boolean;
    shape?: 'circle' | 'square';
    activeColor?: string;
    inactiveClass?: string;
    onDotClick?: (index: number) => void;
}

const PaginationDots = ({
    total,
    currentIndex,
    hidden = false,
    shape = 'circle',
    activeColor = 'bg-[#035D75]',
    inactiveClass = 'bg-[#DDE2E5]',
    onDotClick
}: PaginationDotsProps) => {

    if (hidden || total <= 1) return null;

    const shapeClass = shape === 'circle' ? 'rounded-full w-3 h-3' : 'h-[6px] w-[1.75rem]';

    return (
        <div className="flex gap-2 items-center justify-center">
            {Array.from({ length: total }).map((_, idx) => (
                <button
                    key={idx}
                    onClick={() => onDotClick?.(idx)}
                    className={`${shapeClass} ${idx === currentIndex ? activeColor : inactiveClass} hover:brightness-105`}
                >
                </button>
            ))}
        </div>
    );
};

export default PaginationDots;